(ns hypnos.dme.tile.selection
  "Mask selection tiles."
  (:require [hypnos.dme.subs]
            [hypnos.dme.tile.field.consult-mask-selector-type :as consult-mask-selector-type]
            [hypnos.dme.tile.field.consult-recommendations-note :as consult-recommendations-note]
            [hypnos.dme.tile.field.patient-mask :as patient-mask]
            [hypnos.dme.tile.table.recommendation :as recommendation]
            [hypnos.graphql.mutations :as mutations]
            [hypnos.i18n :refer [tr]]
            [hypnos.translator.patient :as t-p]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- load
  [body]
  (if-let [_loading? @(rf/subscribe [:dme/gql-request-in-progress?])]
    [:div.card-content
     [:section.section
      [:div.content.has-text-grey.has-text-centered
       [:p
        [:span.icon.is-large
         [:i.mdi.mdi-loading.mdi-48px.mdi-spin]]]
       [:p (tr :ui.label/loading)]]]]
    body))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn mask-tile
  "The mask selection tile."
  [state]
  (let [recomms-with-note (rf/subscribe [:dme/recommendations-with-note])
        _                 (swap! state merge (t-p/recommendations-with-note->state @recomms-with-note))]
    [:div#recommendations.tile.is-ancestor
     [:div.tile.is-parent
      [:div.card.tile.is-child
       [:header.header.card-header
        [:p.card-header-title (tr :ui.label/recommendations)]]
       (load
        [:div.card-content
         [recommendation/select-table state]
         [consult-recommendations-note/field state {:disabled true}]])]]]))

(defn custom-mask-tile
  "The custom mask selection tile."
  [state]
  [:div.tile.is-ancestor
   [:div.tile.is-parent
    [:div.card.tile.is-child
     [:header.header.card-header
      [:p.card-header-title (tr :ui.label/other-mask)]
      (when (= :consult-state/pending
               (get-in @state [:patient :patient/last-consult :consult/status :value]))
        [:button.button.is-info
         {:disabled (or (nil? (get-in @state [:recommendations :custom :manufacturer :value]))
                        (nil? (get-in @state [:recommendations :custom :make :value]))
                        (nil? (get-in @state [:recommendations :custom :model :value])))
          :on-click (fn [_]
                      (let [patient (dissoc (t-p/patient->db @state)
                                            :patient/last-consult
                                            :patient/image
                                            :patient/anatomy
                                            :patient/recommendations
                                            :patient/mask
                                            :patient/selector
                                            :patient/selector-type
                                            :consult/_patient
                                            :communication/_recipient)
                            consult       (dissoc (t-p/consult->db @state)
                                                  :consult/user
                                                  :consult/manufacturer
                                                  :consult/make
                                                  :consult/model)
                            model         {:model/id (str (get-in @state [:recommendations :custom :model :value]))}
                            selector-type (get-in @state [:recommendations :custom :selector-type :value])]
                        (swap! state assoc-in [:patient :patient/id :value] nil)
                        (rf/dispatch-sync [:amplify/mutation
                                           mutations/select-mask
                                           {:patient        (t-p/patient->gql patient)
                                            :consult        (t-p/consult->gql consult)
                                            :recommendation (t-p/recommendation->gql {:recommendation/model         model
                                                                                      :recommendation/selector-type selector-type})}
                                           :dme/refresh-patient
                                           :dme/noop])
                        (swap! state assoc
                               :new-consult? false
                               :new-exchange? false)))}
         [:span (tr :ui.label/select)]])]
     (load
      [:div.card-content
       [patient-mask/field state]
       [consult-mask-selector-type/field state]])]]])
